
import { Link } from "react-router-dom";

const GettingStarted = () => {
    return (
        <div>
            <h2 className="mb-6 font-[500] text-center text-4xl lg:text-5xl tracking-wide">
                Getting Started
            </h2>
            <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center lg:grid lg:grid-cols-3 lg:gap-5 justify-items-center">
                <Link to = '/learn/how-to-easily-setup-a-metamask-wallet' className="mb-5 sm:m-5 w-full sm:w-[40%] lg:w-full max-w-[400px] flex flex-col border-[1px] border-gray-700 rounded-[8px]">
                    <img src = 'https://images.unsplash.com/photo-1601592996763-f05c9c80a7f1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' 
                        alt="wallet" className="w-full rounded-t-[8px]"/>
                    <p className="text-sm md:text-base lg:text-lg px-4 py-6 text-center">
                        How to set up a Metamask Wallet
                    </p>
                </Link>
                <Link to = '/learn/how-to-fund-metamask-with-eth' className="mb-5 sm:m-5 w-full sm:w-[40%] lg:w-full max-w-[400px] flex flex-col border-[1px] border-gray-700 rounded-[8px]">
                    <img src = 'https://images.unsplash.com/photo-1639781360241-dadbe5c28dce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2080&q=80' 
                        alt="wallet" className="w-full rounded-t-[8px]"/>
                    <p className="text-sm md:text-base lg:text-lg px-4 py-6 text-center">
                        How to fund Metamask with ETH
                    </p>
                </Link>
                <Link to = '/learn/how-to-find-an-nft-you-love' className="mb-5 sm:m-5 w-full sm:w-[40%] lg:w-full max-w-[400px] flex flex-col border-[1px] border-gray-700 rounded-[8px]">
                    <img src = 'https://images.unsplash.com/photo-1645731504636-72725e46b26b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' 
                        alt="wallet" className="w-full rounded-t-[8px]"/>
                    <p className="text-sm md:text-base lg:text-lg px-4 py-6 text-center">
                        How to find an NFT you Love
                    </p>
                </Link>
            </div> 
        </div>
    )
}

export default GettingStarted;